import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    suppliersBox: {
      maxWidth: 484,
      position: 'relative',
      borderRadius: 20,
      minHeight: 231,
      padding: '24px 32px',
      width: '90vw',
      backgroundColor: 'rgba(152, 165, 183, 0.15)',
      marginBottom: 30,
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: 18,
        minHeight: 210,
        marginBottom: 60,
      },
    },
    title: {
      fontSize: 16,
      fontWeight: 700,
      marginBottom: 20,
    },
    titleManual: {
      fontSize: 16,
      fontWeight: 700,
      marginTop: 16,
      marginBottom: 10,
    },
    subtitleManual: {
      fontSize: 12,
      color: colorVariables.grey80,
      lineHeight: '22px',
      marginBottom: 20,
    },
    label: {
      fontSize: 12,
      marginBottom: 8,
    },
    input: {
      width: '100%',
      height: 48,
      borderRadius: 8,
      padding: 10,
      border: `1px solid ${colorVariables.steelGrey}`,
      backgroundColor: colorVariables.white,
      fontSize: 16,
      outline: 'none',
      boxShadow: 'none',
      '&::placeholder': {
        color: colorVariables.grey60,
      },
      '&:focus': {
        borderColor: colorVariables.blue,
      },
      '&:hover': {
        borderColor: colorVariables.blue,
      },
    },
    menuBox: {
      position: 'relative',
      zIndex: 979,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    menu: {
      position: 'absolute',
      top: 55,
      width: '100%',
      minHeight: 50,
      borderRadius: 6,
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
      backgroundColor: colorVariables.white,
    },
    addBtnWrap: {
      padding: 10,
      borderBottom: `1px solid ${colorVariables.steelGrey}`,
    },
    addSupplierBtn: {
      width: 94,
      height: 24,
      padding: 0,
      fontSize: 12,
      marginLeft: 10,
    },
    addSupplierBtnInApp: {
      width: 103,
      marginRight: 0,
      height: 29,
      padding: 0,
      fontSize: 11,
      marginLeft: 10,
      paddingLeft: 2,
      '& svg': {
        transform: 'translateX(-5px)',
      },
    },
    addSupplierRow: {
      display: 'flex',
      padding: '10px 15px 2px 20px',
      alignItems: 'center',
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: '10px 5px 3px 15px',
      },
    },
    nameWrap: {
      width: '60%',
    },
    logoWrap: {
      marginLeft: 'auto',
      width: 26,
      height: 26,
      borderRadius: '50%',
      border: `1px solid ${colorVariables.steelGrey}`,
      overflow: 'hidden',
      flexShrink: 0,
      '& img': {
        width: '100%',
      },
    },
    addressLine: {
      padding: '0 15px 20px 20px',
      fontSize: 12,
      display: 'flex',
      flexWrap: 'wrap',
      color: colorVariables.grey60,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 11,
        padding: '0 15px 15px 15px',
      },
    },
    suppliersList: {
      height: 220,
      overflowY: 'scroll',
    },
    notFoundText: {
      marginTop: 20,
      fontWeight: 600,
      textAlign: 'center',
      lineHeight: '22px',
    },
    menuLoading: {
      padding: 20,
      color: colorVariables.grey80,
      fontWeight: 600,
    },
    addBtnInbox: {
      marginTop: 20,
      height: 40,
    },
    supplierTile: {
      width: 484,
      minHeight: 86,
      marginBottom: 15,
      boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
      borderRadius: 8,
      padding: 16,
      display: 'flex',
      justifyContent: 'space-between',
      backgroundColor: colorVariables.white,
      '&:last-child': {
        marginBottom: 50,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '90vw',
        padding: '15px 10px',
        '&:last-child': {
          marginBottom: 20,
        },
      },
    },
    suppliersListBox: {
      maxHeight: 300,
      overflowY: 'scroll',
    },
    supplierTileContent: {
      width: 400,
      display: 'flex',
      paddingRight: 10,
      alignSelf: 'center',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: 'auto',
      },
    },
    requestTrigger: {
      width: 103,
      height: 29,
      display: 'flex',
      alignItems: 'center',
      borderRadius: 24,
      backgroundColor: '#DFE3E9',
      color: colorVariables.grey80,
      fontSize: 12,
      fontWeight: 700,
      padding: '5px 10px',
      alignSelf: 'flex-start',
      '& svg': {
        fontSize: 18,
      },
    },
    supplierTileLogo: {
      width: 48,
      height: 48,
      borderRadius: '50%',
      border: `1px solid ${colorVariables.steelGrey}`,
      marginRight: 14,
      overflow: 'hidden',
      flexShrink: 0,
      '& img': {
        width: '100%',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginRight: 10,
      },
    },
    supplerTileName: {
      fontSize: 16,
      fontWeight: 600,
      marginBottom: 5,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 14,
        lineHeight: '18px',
      },
    },
    tileAddrerss: {
      color: colorVariables.grey60,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 12,
      },
    },
    labelManual: {
      fontSize: 12,
    },
    selfBtn: {
      marginTop: 12,
      marginLeft: 0,
      marginRight: 12,
      color: colorVariables.navy,
      backgroundColor: colorVariables.greenLight,
      [theme.breakpoints.down(Sizes.mobile)]: {
        marginRight: 7,
        padding: '5px 10px',
        '&:hover': {
          backgroundColor: colorVariables.greenLight,
          color: colorVariables.navy,
        },
      },
    },
    selfBtnInactive: {
      color: colorVariables.grey60,
      backgroundColor: colorVariables.white,
      borderColor: colorVariables.grey60,
    },
    form: {
      paddingTop: 20,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '&>div': {
        width: '100%',
      },
    },
    field: {
      marginBottom: 10,
    },
    submitBtn: {
      height: 40,
      marginTop: 15,
    },
    btnBox: {
      display: 'flex',
      [theme.breakpoints.down(Sizes.mobile)]: {
        flexDirection: 'column-reverse',
        '& button': {
          marginBottom: 20,
        },
      },
    },
    typeBtnsBox: {
      display: 'flex',
    },
    recommendedText: {
      position: 'absolute',
      width: 97,
      height: 17,
      borderRadius: 8,
      background: 'linear-gradient(right, #33A8E2, #51D9B0)',
      paddingTop: 2,
      fontSize: 10,
      fontWeight: 600,
      color: colorVariables.white,
      textAlign: 'center',
      bottom: -11,
      left: '50%',
      transform: 'translateX(-50%)',
    },
    supplierManagedWrap: {
      position: 'relative',
    },
    track: {
      backgroundColor: colorVariables.steelGrey,
      opacity: 1,
    },
    thumb: {
      backgroundColor: colorVariables.white,
      width: 20,
      height: 20,
    },
    checked: {
      '&.MuiSwitch-switchBase + .MuiSwitch-track': {
        backgroundColor: '#44B5E6',
        opacity: 1,
      },
    },
    orderEmailWrap: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transform: 'translateY(10px)',
      '&>span:first-child': {
        fontWeight: 700,
        fontSize: 12,
        textTransform: 'uppercase',
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        '&>span:first-child': {
          fontSize: 10,
        },
      },
    },
    ordersEmailNote: {
      fontSize: 12,
      marginTop: 8,
      marginBottom: 10,
    },
    addBtnPlus: {
      padding: 5,
      fontSize: 11,
      height: 30,
      color: colorVariables.navy,
      fontWeight: 700,
      '& svg': {
        color: colorVariables.green,
      },
    },
    reqBtnPrimary: {
      backgroundColor: colorVariables.greenLight,
      color: colorVariables.green,
      textAlign: 'center',
      justifyContent: 'center',
    },
  }),
);
